// Styles for the Questionnaire component
const styles = {
  container: {
    p: { xs: 2, sm: 3 },
    mt: 0,
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
    borderRadius: 2,
    boxShadow: (theme) => theme.palette.mode === 'dark' 
      ? '0 8px 16px rgba(0,0,0,0.4)' 
      : '0 8px 16px rgba(0,0,0,0.1)',
  },
  loadingCard: {
    p: 4,
    mt: 2,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 300,
    borderRadius: 2,
  },
  questionSection: {
    mb: 3,
    '& .MuiAccordion-root': {
      '&:before': {
        display: 'none',
      },
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      borderRadius: '12px !important',
      overflow: 'hidden',
      mb: 2.5
    },
    '& .MuiAccordionSummary-root': {
      py: 1,
    }
  },
  header: {
    mb: 4,
    textAlign: { xs: 'center', sm: 'left' },
    borderBottom: '1px solid',
    borderColor: 'divider',
    pb: 2,
  },
  questionTitle: {
    fontWeight: 600,
    fontSize: '1.05rem',
    color: 'text.primary',
  },
  answerField: {
    mt: 1.5,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      }
    }
  },
  submitButton: {
    mt: 4,
    py: 1.5,
    borderRadius: 2,
    fontWeight: 600,
    textTransform: 'none',
    fontSize: '1rem',
    boxShadow: (theme) => theme.palette.mode === 'dark' 
      ? '0 4px 12px rgba(0,0,0,0.4)' 
      : '0 4px 12px rgba(32,101,209,0.24)',
  },
  userAnswerBox: {
    mb: 2.5, 
    px: 2, 
    py: 1.5, 
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider'
  },
  userName: {
    fontWeight: 'bold', 
    mb: 0.5,
    display: 'flex',
    alignItems: 'center',
    '&::before': {
      content: '""',
      display: 'inline-block',
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'primary.main',
      mr: 1
    }
  },
  imageGallerySection: {
    mt: 5,
    pt: 3,
    borderTop: '1px solid',
    borderColor: 'divider',
  },
  imageGalleryTitle: {
    mb: 3,
    fontWeight: 600,
    fontSize: '1.4rem',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: -8,
      left: 0,
      width: 50,
      height: 3,
      backgroundColor: 'primary.main',
      borderRadius: 1,
    }
  },
  userImagesSection: {
    mb: 4,
    p: 2,
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: (theme) => theme.palette.mode === 'dark' 
      ? 'rgba(255,255,255,0.03)' 
      : 'rgba(0,0,0,0.02)'
  },
  userImageName: {
    fontWeight: 600,
    color: 'text.primary',
    display: 'flex',
    alignItems: 'center',
  },
  imageGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
  },
  imageItem: {
    width: { xs: '100%', sm: 200 },
    height: { xs: 'auto', sm: 200 },
    objectFit: 'cover',
    borderRadius: 2,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
  },
  imageUploadSection: {
    mt: 4
  },
  uploadButton: {
    border: '2px dashed',
    borderColor: 'divider',
    borderRadius: 2,
    p: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  imagePreview: {
    mt: 2
  },
  imagePreviewItem: {
    position: 'relative'
  },
  deleteButton: {
    position: 'absolute',
    top: 5,
    right: 5,
    bgcolor: 'rgba(0,0,0,0.5)',
    color: 'white',
    '&:hover': {
      bgcolor: 'rgba(0,0,0,0.7)'
    }
  },
  modalBackdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.8)',
    backdropFilter: 'blur(5px)',
  },
  modalContent: {
    outline: 'none',
    maxWidth: '90vw',
    maxHeight: '90vh',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalImage: {
    maxWidth: '100%',
    maxHeight: '85vh',
    objectFit: 'contain',
    borderRadius: 2,
    boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
  },
  imageGallery: {
    mt: 4,
    mb: 2
  },
  galleryImage: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8
    }
  },
  // Tab navigation styles
  tabsContainer: {
    borderBottom: 1,
    borderColor: 'divider',
    mb: 3
  },
  tab: {
    minWidth: 'auto',
    px: 2,
    py: 1
  },
  tabPanel: {
    mb: 4
  },
  questionTabTitle: {
    fontWeight: 600,
    fontSize: '1.2rem',
    mb: 2,
    color: 'text.primary',
  },
  navigationButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    mt: 4,
    mb: 2
  },
  navButton: {
    minWidth: '100px'
  }
};

export default styles; 